document.addEventListener('DOMContentLoaded', function() {
    const contentBody = document.querySelector('.article-template__content');
    const tocList = document.getElementById('js-toc-list');
    
    if (!contentBody) return;

    // 1. 获取所有需要生成目录的标题 (h2)
    const headings = contentBody.querySelectorAll('h2');
    
    if (headings.length === 0) {
      // 如果没有标题，则隐藏整个目录区域
      document.querySelector('.article-template__toc').style.display = 'none';
      return;
    }

    headings.forEach((heading, index) => {
      // 2. 给每个标题添加唯一的 ID
      const id = 'section-' + index;
      heading.setAttribute('id', id);

      // 3. 动态生成左侧目录列表项
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = '#' + id;
      a.textContent = heading.textContent;
      a.dataset.targetId = id; // 存储目标ID，方便后续查找
      
      // 点击事件：平滑滚动到对应位置
      a.addEventListener('click', function(e) {
        e.preventDefault();
        const targetElement = document.getElementById(this.dataset.targetId);
        if (targetElement) {
          const headerOffset = 100; // 考虑到固定头部的高度
          const elementPosition = targetElement.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
  
          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
          });
        }
      });
      
      li.appendChild(a);
      tocList.appendChild(li);
    });

    // 4. 监听滚动事件，高亮当前所在的章节
    if ('IntersectionObserver' in window) {
      const observerOptions = {
        root: null,
        rootMargin: '-100px 0px -70% 0px', // 调整视口触发区域，让高亮更灵敏
        threshold: 0
      };

      const observer = new IntersectionObserver(function(entries) {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // 【关键修改】找到当前进入视口的标题对应的链接
            const activeId = entry.target.id;
            
            // 移除所有旧的高亮状态
            tocList.querySelectorAll('a').forEach(link => link.classList.remove('is-active'));
            
            // 添加当前的高亮状态
            const currentLink = tocList.querySelector('a[data-target-id="' + activeId + '"]');
            if (currentLink) {
              currentLink.classList.add('is-active');
            }
          }
        });

      }, observerOptions);

      headings.forEach(heading => observer.observe(heading));

      // 稍微延迟执行，确保 IntersectionObserver 已经注册完毕
      setTimeout(() => {
          if (tocList.querySelector('a.is-active') === null) {
              const firstLink = tocList.querySelector('a[data-target-id="section-0"]');
              if (firstLink) firstLink.classList.add('is-active');
          }
      }, 100);
      
    }
  });